import {
  TRANSFER_OMS_COMMAND_PENDING,
  TRANSFER_OMS_COMMAND_REJECTED,
  TRANSFER_OMS_COMMAND_FULFILLED,
  CLEAR_TRANSFER_OMS_COMMAND
} from "../constants/transferOmsCommand";
import { isRequestSuccessful } from "../theme/utils";

const initialState = {
  pending: false,
  omsCommandResponse: {},
  success: false,
  error: {}
};

export const omsCommand = (state = initialState, action) => {
  switch (action.type) {
    case TRANSFER_OMS_COMMAND_PENDING:
      return { ...state, pending: true, error: {} };

    case TRANSFER_OMS_COMMAND_REJECTED:
      return {
        ...state,
        pending: false,
        error: action.error
      };

    case TRANSFER_OMS_COMMAND_FULFILLED:
      return {
        ...state,
        omsCommandResponse: action.response.data,
        success: isRequestSuccessful(action.response.status),
        pending: false,
        error: {}
      };

    case CLEAR_TRANSFER_OMS_COMMAND:
      return initialState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/transferOmsCommand.js